import * as utils from './utils';

const provider = { 
  getTeacherSpokenLanguages: teacherId => utils.get(`teacher/${teacherId}/spoken_languages`)
};

export default provider;